<div class="tw-relative tw-rounded-t-[20px] tw-bg-orange-100 tw-px-6 tw-pb-6 tw-pt-9" data-node-id="66623:80886">
  <div class="tw-absolute tw-left-1/2 tw-top-2 tw-h-1 tw-w-20 -tw-translate-x-1/2 tw-rounded-full tw-bg-gray-200"></div>
  <span type="button" class="tw-absolute tw-right-4 tw-top-3 tw-text-800 tw-leading-none tw-text-gray-500" aria-label="close" i18n-aria-label="@@close" (click)="close()">×</span>

  <div class="tw-mb-4 tw-flex tw-items-center tw-gap-3">
    <div class="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-75">
      <img class="tw-h-6 tw-w-6" src="/assets/images/3000_crown.svg" alt="" />
    </div>
    <h2 class="tw-font-lexend tw-text-[20px] tw-font-bold tw-leading-[26px] tw-text-gray-800"><span i18n="@@premiumService">Priority Care</span><br />@ ₹800</h2>
  </div>

  <div class="tw-rounded-xl tw-bg-gray-75 tw-px-4 tw-py-3">
    @for (benefit of benefits; track benefit.id) {
      <div class="tw-flex tw-items-center tw-gap-3 tw-py-2">
        <span class="tw-flex tw-h-6 tw-w-6 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-text-xs tw-font-bold tw-text-white" [class]="benefit.colorClass"><img class="tw-h-4 tw-w-4 tw-object-contain" [src]="benefit.icon" alt="" /></span>
        <div>
          @switch (benefit.id) {
            @case ('doctor') {
              <p class="tw-font-lexend tw-text-[14px] tw-font-bold tw-leading-[17px] tw-text-gray-800" i18n="@@premiumServiceDoctorVideoCall">1 Doctor Video Call</p>
              <p class="tw-font-body tw-text-[10px] tw-leading-[15px] tw-text-gray-500" i18n="@@premiumServiceDoctorVideoCallSubtitle">Face to face consultation with doctor</p>
            }
            @case ('nutritionist') {
              <p class="tw-font-lexend tw-text-[14px] tw-font-bold tw-leading-[17px] tw-text-gray-800" i18n="@@premiumServiceNutritionistCalls">2 Nutritionist Calls</p>
              <p class="tw-font-body tw-text-[10px] tw-leading-[15px] tw-text-gray-500" i18n="@@premiumServiceNutritionistCallsSubtitle">Diet and lifestyle guidance</p>
            }
            @case ('priority') {
              <p class="tw-font-lexend tw-text-[14px] tw-font-bold tw-leading-[17px] tw-text-gray-800" i18n="@@premiumServicePrioritySupport">Priority Support</p>
              <p class="tw-font-body tw-text-[10px] tw-leading-[15px] tw-text-gray-500" i18n="@@premiumServicePrioritySupportSubtitle">Faster assistance whenever you need help</p>
            }
            @case ('cash') {
              <p class="tw-font-lexend tw-text-[14px] tw-font-bold tw-leading-[17px] tw-text-gray-800">₹200 <span i18n="@@cureskinCash">Cure Cash</span></p>
              <p class="tw-font-body tw-text-[10px] tw-leading-[15px] tw-text-gray-500" i18n="@@premiumServiceCureCashSubtitle">Redeem on your next Cure purchase</p>
            }
            @case ('perks') {
              <p class="tw-font-lexend tw-text-[14px] tw-font-bold tw-leading-[17px] tw-text-gray-800" i18n="@@premiumServiceExclusivePerks">Exclusive Premium Perks</p>
              <p class="tw-font-body tw-text-[10px] tw-leading-[15px] tw-text-gray-500" i18n="@@premiumServiceExclusivePerksSubtitle">Special offers and benefits</p>
            }
          }
        </div>
      </div>
    }
  </div>

  <button type="button" class="tw-mt-4 tw-h-12 tw-w-full tw-rounded-xl tw-bg-teal-600 tw-font-lexend tw-text-[18px] tw-font-semibold tw-text-white" (click)="confirm()">
    <span><span i18n="@@addPremiumServiceToPlan">Add to plan</span> + ₹800</span>
  </button>
</div>
